const loadScript = (src:string)  => {
  return new Promise(function (resolve, reject) {
    var s;
    s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

const drupalSettings = () => {
  const settingBlock = document.querySelector('[data-drupal-selector="drupal-settings-json"]')
  if (!settingBlock) {
    return null
  }

  return JSON.parse(settingBlock.innerHTML)
}

export {
  drupalSettings,
  loadScript
}
